import { Navigate, useParams } from 'react-router-dom'

export default function NavigateToProduct() {
  const { id } = useParams()
  return <Navigate to={`/campaign/${id}?tab=product`} />
}
